class DictionaryFilter {
    static filterByActiveItem(items) {
        return (items !== null && items !== void 0 ? items : []).filter(DictionaryFilter.byActiveItem);
    }
    static filterByInactiveItem(items) {
        return (items !== null && items !== void 0 ? items : []).filter(DictionaryFilter.byInactiveItem);
    }
    static byActiveItem(item) {
        var _a, _b;
        return (_b = (_a = item.active) !== null && _a !== void 0 ? _a : item.isActive) !== null && _b !== void 0 ? _b : true;
    }
    static byInactiveItem(item) {
        return !DictionaryFilter.byActiveItem(item);
    }
}

export { DictionaryFilter as D };
//# sourceMappingURL=dictionaryFilter-769f7408.js.map
